import React from 'react';
import Modal from 'react-native-modal';
import { metrics } from 'src/themes/Metrics';
import { Container, RegularText, Row, SizedBox } from '../bases';
import { PrimaryButton } from '../buttons';

interface Props {
  onClose: () => void;
  isVisible: boolean;
}

export const ExitModal = ({ onClose, isVisible }: Props) => {
  const handleConfirmPressed = () => {
    onClose();
    // exiting with JS injector from web
    window?.nham24?.request('app/close', {});
  };

  return (
    <Modal onBackButtonPress={onClose} onBackdropPress={onClose} isVisible={isVisible}>
      <Container borderRadius={metrics.borderRadius} padding={metrics.large} backgroundColor="white">
        <RegularText fontWeight="bold" textAlign="center" textLang="nham24BusTicket" />
        <SizedBox />
        <RegularText textAlign="center" textLang="areYouSureWantToCloseBusTicket" />
        <SizedBox />
        <Row>
          <PrimaryButton transparent row text="cancel" onPress={onClose} />
          <SizedBox />
          <PrimaryButton row text="confirm" onPress={handleConfirmPressed} />
        </Row>
      </Container>
    </Modal>
  );
};
